/**
 * Capa bloqueante para operaciones cortas que el usuario dispara a mano
 * (generar la captura, enviar el reporte por correo).
 *
 * Se muestra por encima de cualquier modal (`z-[60]`) y cubre el viewport
 * completo, así que ningún control queda accesible mientras dura la operación.
 *
 * A propósito NO fija `overflow:hidden` en el body: al ocultar la barra de
 * desplazamiento cambia el ancho disponible, y este overlay convive con la
 * captura de html2canvas — un reflujo a media captura deforma la imagen que
 * se está generando.
 */
const OverlayProceso = ({ visible, titulo = "Procesando…", detalle = "" }) => {
  if (!visible) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-900/70 p-4 backdrop-blur-sm"
      role="alertdialog"
      aria-busy="true"
      aria-live="assertive"
    >
      <div className="w-full max-w-xs rounded-2xl bg-white px-6 py-7 text-center shadow-2xl">
        <span className="mx-auto block h-12 w-12 animate-spin rounded-full border-4 border-blue-100 border-t-blue-600" />

        <p className="mt-5 font-bold text-gray-900">{titulo}</p>
        {detalle && <p className="mt-1 text-sm text-gray-500">{detalle}</p>}

        {/* Barra indeterminada: la operación no reporta avance real, así que
            no se finge un porcentaje. */}
        <div className="mt-5 h-1.5 w-full overflow-hidden rounded-full bg-gray-100">
          <div className="h-full w-1/3 animate-[pulse_1.2s_ease-in-out_infinite] rounded-full bg-blue-600" />
        </div>
      </div>
    </div>
  );
};

export default OverlayProceso;
